import activities from "./activities.json" assert { type: "json" };
import components from "./components.json" assert { type: "json" };
import communication from "./communication.json" assert { type: "json" };
import candidates from "./candidates.json" assert { type: "json" };
import career from "./career.json" assert { type: "json" };
import jobs from "./jobs.json" assert { type: "json" };
import reports from "./reports.json" assert { type: "json" };
import settings from "./settings.json" assert { type: "json" };
import modals from "./modals.json" assert { type: "json" };
import admins from "./admins.json" assert { type: "json" };
import agency from "./agency.json" assert { type: "json" };
import sidebar from "./sidebar.json" assert { type: "json" };

const da = {
  ...sidebar,
  ...activities,
  ...components,
  ...communication,
  ...candidates,
  ...jobs,
  ...career,
  ...reports,
  ...settings,
  ...modals,
  ...admins,
  ...agency,
};

export default da;
